module.exports = __webpack_public_path__ + "static/media/5 lion leg black white.1280x1480.b964ef51.webp";